import { render, staticRenderFns } from "./ResearchSectionVisualizers.vue?vue&type=template&id=e413ffda"
import script from "./ResearchSectionVisualizers.vue?vue&type=script&lang=js"
export * from "./ResearchSectionVisualizers.vue?vue&type=script&lang=js"
import style0 from "./ResearchSectionVisualizers.vue?vue&type=style&index=0&id=e413ffda&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/Adipose Gateway - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e413ffda')) {
      api.createRecord('e413ffda', component.options)
    } else {
      api.reload('e413ffda', component.options)
    }
    module.hot.accept("./ResearchSectionVisualizers.vue?vue&type=template&id=e413ffda", function () {
      api.rerender('e413ffda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/ResearchSectionVisualizers.vue"
export default component.exports